import { PolicyAttachmentType } from '~domain/model/policy/attachment/policy-attachment-type';

interface PolicyAttachmentConfig {
  isPublic: boolean;
  notifyUser: boolean;
  notifyBroker: boolean;
}

export const policyAttachmentTypeConfig: Record<PolicyAttachmentType, PolicyAttachmentConfig> = {
  // Billing
  [PolicyAttachmentType.PaymentScheduleNoPolicyTransaction]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.BillingWithdrawalRejectionNotice]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: true,
  },
  [PolicyAttachmentType.BillingOverduePaymentNotice]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.BillingFinalBillNotice]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.BillingRefundIssued]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.PaymentReceivedPolicyReinstated]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.PaymentRequiredOutstandingBalance]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.BillingCollectionNotice]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.BillingCreditCardExpired]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: true,
  },

  // Cancellation
  [PolicyAttachmentType.InsurerNonRenewal]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: true,
  },
  [PolicyAttachmentType.InsurerCancellationReinstatable]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: true,
  },
  [PolicyAttachmentType.InsurerCancellationDefinitive]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: true,
  },
  [PolicyAttachmentType.InsuredCancellationRequest]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: true,
  },
  [PolicyAttachmentType.InsurerCancellation]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: true,
  },

  // Policy transaction
  // New business
  [PolicyAttachmentType.NewBusinessPolicyDeclaration]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.NewBusinessLiabilityCertificates]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.NewBusinessPaymentSchedule]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  // Renewal
  [PolicyAttachmentType.RenewalPolicyDeclaration]: {
    isPublic: true,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.RenewalLiabilityCertificates]: {
    isPublic: true,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.RenewalPaymentSchedule]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  // Policy change
  [PolicyAttachmentType.PolicyChangePolicyDeclaration]: {
    isPublic: true,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.PolicyChangeLiabilityCertificates]: {
    isPublic: true,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.PolicyChangePaymentSchedule]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  // Reissue
  [PolicyAttachmentType.ReissuePolicyDeclaration]: {
    isPublic: true,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.ReissueLiabilityCertificates]: {
    isPublic: true,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.ReissuePaymentSchedule]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: false,
  },
  // Rewrite
  [PolicyAttachmentType.RewritePolicyDeclaration]: {
    isPublic: true,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.RewriteLiabilityCertificates]: {
    isPublic: true,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.RewritePaymentSchedule]: {
    isPublic: true,
    notifyUser: false,
    notifyBroker: false,
  },
  // Reinstatement
  [PolicyAttachmentType.ReinstatementPolicyDeclaration]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.ReinstatementLiabilityCertificates]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.ReinstatementPaymentSchedule]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },

  // Underwriting
  [PolicyAttachmentType.UnderwritingRequest]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: true,
  },

  // Claim
  [PolicyAttachmentType.ClaimOpeningNotice]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.ClaimClosingNotice]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.ClaimAdjusterAssignment]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.ClaimAutoRentalNotice]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.ClaimTotalLossNotice]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.ClaimAutoFaultDeterminationNotice]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.ClaimPaymentNotice]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: false,
  },

  // Youset
  [PolicyAttachmentType.PolicyContract]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.BillingStatement]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.BillingNotice]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.CancellationNotice]: {
    isPublic: true,
    notifyUser: true,
    notifyBroker: false,
  },
  [PolicyAttachmentType.OkEDelivery]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: false,
  },
  [PolicyAttachmentType.Unknown]: {
    isPublic: false,
    notifyUser: false,
    notifyBroker: false,
  },
};
